module.exports = __webpack_public_path__ + "img/engenious.80e3c185.svg";